
/**
 * ISO Country code list created from https://wikipedia.org/wiki/ISO_3166-1_alfa-3
 * In order to match BE values on:
 * https://bitbucket.org/exporodev/exporo_ident/src/master/application/config/enums.php
 *
*/
const countryCodesEnum = Object.assign({
  ABW: { name: 'Aruba', backendValue: 'AW' },
  AFG: { name: 'Afghanistan', backendValue: 'AF' },
  AGO: { name: 'Angola', backendValue: 'AO' },
  AIA: { name: 'Anguilla', backendValue: 'AI' },
  ALA: { name: 'Åland Islands', backendValue: 'AX' },
  ALB: { name: 'Albania', backendValue: 'AL' },
  AND: { name: 'Andorra', backendValue: 'AD' },
  ANT: { name: 'Netherlands Antilles', backendValue: 'AN' },
  ARE: { name: 'United Arab Emirates', backendValue: 'AE' },
  ARG: { name: 'Argentina', backendValue: 'AR' },
  ARM: { name: 'Armenia', backendValue: 'AM' },
  ASM: { name: 'American Samoa', backendValue: 'AS' },
  ATA: { name: 'Antárctica', backendValue: 'AQ' },
  ATF: { name: 'French Southern Territories', backendValue: 'TF' },
  ATG: { name: 'Antigua and Barbuda', backendValue: 'AG' },
  AUS: { name: 'Australia', backendValue: 'AU' },
  AUT: { name: 'Austria', backendValue: 'AT' },
  AZE: { name: 'Azerbaijan', backendValue: 'AZ' },
  BDI: { name: 'Burundi', backendValue: 'BI' },
  BEL: { name: 'Belgium', backendValue: 'BE' },
  BEN: { name: 'Benin', backendValue: 'BJ' },
  BFA: { name: 'Burkina Faso', backendValue: 'BF' },
  BGD: { name: 'Bangladesh', backendValue: 'BD' },
  BGR: { name: 'Bulgaria', backendValue: 'BG' },
  BHR: { name: 'Bahrain', backendValue: 'BH' },
  BHS: { name: 'Bahamas', backendValue: 'BS' },
  BIH: { name: 'Bosnia and Herzegovina', backendValue: 'BA' },
  BLR: { name: 'Belarus', backendValue: 'BY' },
  BLZ: { name: 'Belize', backendValue: 'BZ' },
  BMU: { name: 'Bermuda', backendValue: 'BM' },
  BOL: { name: 'Bolivia', backendValue: 'BO' },
  BRA: { name: 'Brazil', backendValue: 'BR' },
  BRB: { name: 'Barbados', backendValue: 'BB' },
  BRN: { name: 'Brunei Darussalam', backendValue: 'BN' },
  BTN: { name: 'Bhutan', backendValue: 'BT' },
  BVT: { name: 'Bouvet Island', backendValue: 'BV' },
  BWA: { name: 'Botswana', backendValue: 'BW' },
  CAF: { name: 'Central African Republic', backendValue: 'CF' },
  CAN: { name: 'Canada', backendValue: 'CA' },
  CCK: { name: 'Cocos (Keeling) Islands', backendValue: 'CC' },
  CHE: { name: 'Switzerland', backendValue: 'CH' },
  CHL: { name: 'Chile', backendValue: 'CL' },
  CHN: { name: 'China', backendValue: 'CN' },
  CIV: {
    name: 'Côte d\'Ivoire', backendValue: 'CI',
  },
  CMR: { name: 'Cameroon', backendValue: 'CM' },
  COD: { name: 'Congo, Democratic Republic of the', backendValue: 'CD' },
  COG: { name: 'Congo, Republic of the', backendValue: 'CG' },
  COK: { name: 'Cook Islands', backendValue: 'CK' },
  COL: { name: 'Colombia', backendValue: 'CO' },
  COM: { name: 'Comoros', backendValue: 'KM' },
  CPV: { name: 'Cape Verde', backendValue: 'CV' },
  CRI: { name: 'Costa Rica', backendValue: 'CR' },
  CUB: { name: 'Cuba', backendValue: 'CU' },
  CXR: { name: 'Christmas Island', backendValue: 'CX' },
  CYM: { name: 'Cayman Islands', backendValue: 'KY' },
  CYP: { name: 'Cyprus', backendValue: 'CY' },
  CZE: { name: 'Czechia', backendValue: 'CZ' },
  DEU: { name: 'Germany', backendValue: 'DE' },
  DJI: { name: 'Djibouti', backendValue: 'DJ' },
  DMA: { name: 'Dominica', backendValue: 'DM' },
  DNK: { name: 'Denmark', backendValue: 'DK' },
  DOM: { name: 'Dominican Republic', backendValue: 'DO' },
  DZA: { name: 'Algeria', backendValue: 'DZ' },
  ECU: { name: 'Ecuador', backendValue: 'EC' },
  EGY: { name: 'Egypt', backendValue: 'EG' },
  ERI: { name: 'Eritrea', backendValue: 'ER' },
  ESH: { name: 'Western Sahara', backendValue: 'EH' },
  ESP: { name: 'Spain', backendValue: 'ES' },
  EST: { name: 'Estonia', backendValue: 'EE' },
  ETH: { name: 'Ethiopia', backendValue: 'ET' },
  FIN: { name: 'Finland', backendValue: 'FI' },
  FJI: { name: 'Fiji', backendValue: 'FJ' },
  FLK: {
    name: 'Falkland Islands(Malvinas)', backendValue: 'FK',
  },
  FRA: { name: 'France', backendValue: 'FR' },
  FRO: { name: 'Faroe Islands', backendValue: 'FO' },
  FSM: { name: 'Micronesia Federated States of', backendValue: 'FM' },
  GAB: { name: 'Gabon', backendValue: 'GA' },
  GBR: { name: 'United Kingdom', backendValue: 'GB' },
  GEO: { name: 'Georgia', backendValue: 'GE' },
  GGY: { name: 'Guernsey', backendValue: 'GG' },
  GHA: { name: 'Ghana', backendValue: 'GH' },
  GIB: { name: 'Gibraltar', backendValue: 'GI' },
  GIN: { name: 'Guinea', backendValue: 'GN' },
  GLP: { name: 'Guadeloupe', backendValue: 'GP' },
  GMB: { name: 'Gambia', backendValue: 'GM' },
  GNB: { name: 'Guinea - Bissau', backendValue: 'GW' },
  GNQ: { name: 'Equatorial Guinea', backendValue: 'GQ' },
  GRC: { name: 'Greece', backendValue: 'GR' },
  GRD: { name: 'Grenada', backendValue: 'GD' },
  GRL: { name: 'Greenland', backendValue: 'GL' },
  GTM: { name: 'Guatemala', backendValue: 'GT' },
  GUF: { name: 'French Guiana', backendValue: 'GF' },
  GUM: { name: 'Guam', backendValue: 'GU' },
  GUY: { name: 'Guyana', backendValue: 'GY' },
  HKG: { name: 'Hong Kong', backendValue: 'HK' },
  HMD: { name: 'Heard Island and McDonald Islands', backendValue: 'HM' },
  HND: { name: 'Honduras', backendValue: 'HN' },
  HRV: { name: 'Croatia', backendValue: 'HR' },
  HTI: { name: 'Haiti', backendValue: 'HT' },
  HUN: { name: 'Hungary', backendValue: 'HU' },
  IDN: { name: 'Indonesia', backendValue: 'ID' },
  IMN: { name: 'Isle of Man', backendValue: 'IM' },
  IND: { name: 'India', backendValue: 'IN' },
  IOT: { name: 'British Indian Ocean Territory', backendValue: 'IO' },
  IRL: { name: 'Ireland', backendValue: 'IE' },
  IRN: { name: 'Iran, Islamic Republic of', backendValue: 'IR' },
  IRQ: { name: 'Iraq', backendValue: 'IQ' },
  ISL: { name: 'Iceland', backendValue: 'IS' },
  ISR: { name: 'Israel', backendValue: 'IL' },
  ITA: { name: 'Italy', backendValue: 'IT' },
  JAM: { name: 'Jamaica', backendValue: 'JM' },
  JEY: { name: 'Jersey', backendValue: 'JE' },
  JOR: { name: 'Jordan', backendValue: 'JO' },
  JPN: { name: 'Japan', backendValue: 'JP' },
  KAZ: { name: 'Kazakhstan', backendValue: 'KZ' },
  KEN: { name: 'Kenya', backendValue: 'KE' },
  KGZ: { name: 'Kyrgyzstan', backendValue: 'KG' },
  KHM: { name: 'Cambodia', backendValue: 'KH' },
  KIR: { name: 'Kiribati', backendValue: 'KI' },
  KNA: { name: 'Saint Kitts and Nevis', backendValue: 'KN' },
  KOR: { name: 'Korea, Republic of', backendValue: 'KR' },
  KWT: { name: 'Kuwait', backendValue: 'KW' },
  LAO: {
    name: 'Lao People\'s Democratic Republic', backendValue: 'LA',
  },
  LBN: { name: 'Lebanon', backendValue: 'LB' },
  LBR: { name: 'Liberia', backendValue: 'LR' },
  LBY: { name: 'Libyan Arab Jamahiriya', backendValue: 'LY' },
  LCA: { name: 'Saint Lucia', backendValue: 'LC' },
  LIE: { name: 'Liechtenstein', backendValue: 'LI' },
  LKA: { name: 'Sri Lanka', backendValue: 'LK' },
  LSO: { name: 'Lesotho', backendValue: 'LS' },
  LTU: { name: 'Lithuania', backendValue: 'LT' },
  LUX: { name: 'Luxembourg', backendValue: 'LU' },
  LVA: { name: 'Latvia', backendValue: 'LV' },
  MAC: { name: 'Macao', backendValue: 'MO' },
  MAR: { name: 'Morocco', backendValue: 'MA' },
  MCO: { name: 'Monaco', backendValue: 'MC' },
  MDA: { name: 'Moldova, Republic of', backendValue: 'MD' },
  MDG: { name: 'Madagascar', backendValue: 'MG' },
  MDV: { name: 'Maldives', backendValue: 'MV' },
  MEX: { name: 'Mexico', backendValue: 'MX' },
  MHL: { name: 'Marshall Islands', backendValue: 'MH' },
  MKD: { name: 'Macedonia the former Yugoslav, Republic of', backendValue: 'MK' },
  MLI: { name: 'Mali', backendValue: 'ML' },
  MLT: { name: 'Malta', backendValue: 'MT' },
  MMR: { name: 'Myanmar', backendValue: 'MM' },
  MNE: { name: 'Montenegro', backendValue: 'ME' },
  MNG: { name: 'Mongolia', backendValue: 'MN' },
  MNP: { name: 'Northern Mariana Islands', backendValue: 'MP' },
  MOZ: { name: 'Mozambique', backendValue: 'MZ' },
  MRT: { name: 'Mauritania', backendValue: 'MR' },
  MSR: { name: 'Montserrat', backendValue: 'MS' },
  MTQ: { name: 'Martinique', backendValue: 'MQ' },
  MUS: { name: 'Mauritius', backendValue: 'MU' },
  MWI: { name: 'Malawi', backendValue: 'MW' },
  MYS: { name: 'Malaysia', backendValue: 'MY' },
  MYT: { name: 'Mayotte', backendValue: 'YT' },
  NAM: { name: 'Namibia', backendValue: 'NA' },
  NCL: { name: 'New Caledonia', backendValue: 'NC' },
  NER: { name: 'Niger', backendValue: 'NE' },
  NFK: { name: 'Norfolk Island', backendValue: 'NF' },
  NGA: { name: 'Nigeria', backendValue: 'NG' },
  NIC: { name: 'Nicaragua', backendValue: 'NI' },
  NIU: { name: 'Niue', backendValue: 'NU' },
  NLD: { name: 'Netherlands', backendValue: 'NL' },
  NOR: { name: 'Norway', backendValue: 'NO' },
  NPL: { name: 'Nepal', backendValue: 'NP' },
  NRU: { name: 'Nauru', backendValue: 'NR' },
  NZL: { name: 'New Zealand', backendValue: 'NZ' },
  OMN: { name: 'Oman', backendValue: 'OM' },
  PAK: { name: 'Pakistan', backendValue: 'PK' },
  PAN: { name: 'Panama', backendValue: 'PA' },
  PCN: { name: 'Pitcairn', backendValue: 'PN' },
  PER: { name: 'Peru', backendValue: 'PE' },
  PHL: { name: 'Philippines', backendValue: 'PH' },
  PLW: { name: 'Palau', backendValue: 'PW' },
  PNG: { name: 'Papua New Guinea', backendValue: 'PG' },
  POL: { name: 'Poland', backendValue: 'PL' },
  PRI: { name: 'Puerto Rico', backendValue: 'PR' },
  PRK: {
    name: 'Korea, Democratic People\'s Republic of', backendValue: 'KP',
  },
  PRT: { name: 'Portugal', backendValue: 'PT' },
  PRY: { name: 'Paraguay', backendValue: 'PY' },
  PSE: { name: 'Palestinian Territory Occupied', backendValue: 'PS' },
  PYF: { name: 'French Polynesia', backendValue: 'PF' },
  QAT: { name: 'Qatar', backendValue: 'QA' },
  REU: { name: 'Réunion', backendValue: 'RE' },
  ROU: { name: 'Romania', backendValue: 'RO' },
  RUS: { name: 'Russia', backendValue: 'RU' },
  RWA: { name: 'Rwanda', backendValue: 'RW' },
  SAU: { name: 'Saudi Arabia', backendValue: 'SA' },
  SDN: { name: 'Sudan', backendValue: 'SD' },
  SEN: { name: 'Senegal', backendValue: 'SN' },
  SGP: { name: 'Singapore', backendValue: 'SG' },
  SGS: { name: 'South Georgia and the South Sandwich Islands', backendValue: 'GS' },
  SHN: { name: 'Saint Helena', backendValue: 'SH' },
  SJM: { name: 'Svalbard and Jan Mayen', backendValue: 'SJ' },
  SLB: { name: 'Solomon Islands', backendValue: 'SB' },
  SLE: { name: 'Sierra Leone', backendValue: 'SL' },
  SLV: { name: 'El Salvador', backendValue: 'SV' },
  SMR: { name: 'San Marino', backendValue: 'SM' },
  SOM: { name: 'Somalia', backendValue: 'SO' },
  SPM: { name: 'Saint Pierre and Miquelon', backendValue: 'PM' },
  SRB: { name: 'Serbia', backendValue: 'RS' },
  STP: { name: 'Sao Tome and Principe', backendValue: 'ST' },
  SUR: { name: 'Suriname', backendValue: 'SR' },
  SVK: { name: 'Slovakia', backendValue: 'SK' },
  SVN: { name: 'Slovenia', backendValue: 'SI' },
  SWE: { name: 'Sweden', backendValue: 'SE' },
  SWZ: { name: 'Swaziland', backendValue: 'SZ' },
  SYC: { name: 'Seychelles', backendValue: 'SC' },
  SYR: { name: 'Syrian Arab Republic', backendValue: 'SY' },
  TCA: { name: 'Turks and Caicos Islands', backendValue: 'TC' },
  TCD: { name: 'Chad', backendValue: 'TD' },
  TGO: { name: 'Togo', backendValue: 'TG' },
  THA: { name: 'Thailand', backendValue: 'TH' },
  TJK: { name: 'Tajikistan', backendValue: 'TJ' },
  TKL: { name: 'Tokelau', backendValue: 'TK' },
  TKM: { name: 'Turkmenistan', backendValue: 'TM' },
  TLS: { name: 'Timor - Leste', backendValue: 'TL' },
  TON: { name: 'Tonga', backendValue: 'TO' },
  TTO: { name: 'Trinidad and Tobago', backendValue: 'TT' },
  TUN: { name: 'Tunisia', backendValue: 'TN' },
  TUR: { name: 'Turkey', backendValue: 'TR' },
  TUV: { name: 'Tuvalu', backendValue: 'TV' },
  TWN: { name: 'Taiwan Province of China', backendValue: 'TW' },
  TZA: { name: 'Tanzania, United Republic of', backendValue: 'TZ' },
  UGA: { name: 'Uganda', backendValue: 'UG' },
  UKR: { name: 'Ukraine', backendValue: 'UA' },
  UMI: { name: 'United States Minor Outlying Islands', backendValue: 'UM' },
  URY: { name: 'Uruguay', backendValue: 'UY' },
  USA: { name: 'United States', backendValue: 'US' },
  UZB: { name: 'Uzbekistan', backendValue: 'UZ' },
  VAT: {
    name: 'Holy See(Vatican City State) ', backendValue: 'VA',
  },
  VCT: { name: 'Saint Vincent and the Grenadines', backendValue: 'VC' },
  VEN: { name: 'Venezuela', backendValue: 'VE' },
  VGB: { name: 'Virgin Islands British', backendValue: 'VG' },
  VIR: {
    name: 'Virgin Islands U.S.', backendValue: 'VI',
  },
  VNM: { name: 'Viet Nam', backendValue: 'VN' },
  VUT: { name: 'Vanuatu', backendValue: 'VU' },
  WLF: { name: 'Wallis and Futuna', backendValue: 'WF' },
  WSM: { name: 'Samoa', backendValue: 'WS' },
  YEM: { name: 'Yemen', backendValue: 'YE' },
  ZAF: { name: 'South Africa', backendValue: 'ZA' },
  ZMB: { name: 'Zambia', backendValue: 'ZM' },
  ZWE: { name: 'Zimbabwe', backendValue: 'ZW' },
});

Object.freeze(countryCodesEnum);

function getEnumAsArray() {
  return Object.keys(countryCodesEnum)
    .map(key => ({
      name: countryCodesEnum[key].name,
      value: key,
      backendValue: countryCodesEnum[key].backendValue,
    }));
}

export const countryCodesArray = getEnumAsArray();
export default countryCodesEnum;



// WEBPACK FOOTER //
// ./src/enum/CountryCodesEnum.js